const GOOGLE_PLACES_API_KEY = 'AIzaSyDpMe6JvgwX5Ska_YfWuMvDY7GuCpcKz9U'

let loadPromise: Promise<void> | null = null

export const loadGoogleMaps = (): Promise<void> => {
    if (loadPromise) return loadPromise
    const g = (window as any).google
    if (g && g.maps) {
        return Promise.resolve()
    }

    loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_PLACES_API_KEY}&libraries=places&language=he`
        script.async = true
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Failed to load Google Maps'))
        document.head.appendChild(script)
    })

    return loadPromise
}
